function tokenVerify(token) {
    return new Promise((resolve, reject) => {
        const http       = new XMLHttpRequest();
        const input_data = { token };
        const csrf       = document.querySelector(`meta[name="csrf-token"]`);

        http.open("POST", "/api/token-verify", true);

        http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        http.setRequestHeader("Authorization", `Bearer ${token}`);

        http.setRequestHeader("X-CSRF-TOKEN", csrf ? csrf.getAttribute(`content`) : "");

        http.onreadystatechange = function() {
            if(http.readyState === 4) {
                if(http.status == 200) {
                    const response_data = JSON.parse(http.responseText);

                    resolve(response_data);
                }else {
                    reject(http.statusText);
                }
            }
        }

        http.send(JSON.stringify(input_data));
    });
}

function signout(token) {
    return new Promise((resolve, reject) => {
        const http       = new XMLHttpRequest();
        const input_data = {};
        const csrf       = document.querySelector(`meta[name="csrf-token"]`);

        http.open("POST", "/api/logout", true);

        http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        
        http.setRequestHeader("Authorization", `Bearer ${token}`);

        http.setRequestHeader("X-CSRF-TOKEN", csrf ? csrf.getAttribute(`content`) : "");

        http.onreadystatechange = function() {
            if(http.readyState === 4) {
                if(http.status == 200) {
                    const response_data = JSON.parse(http.responseText);
                    
                    localStorage.removeItem("token");
                    window.location.href = "/";

                    resolve(response_data);
                }else {
                    reject(http.statusText);
                }
            }
        }

        http.send(JSON.stringify(input_data));
    });
}

function httpRequest(request_type, URI, headers, input_data) {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();

        http.open(request_type, URI, true);

        for(const key in headers) {
            http.setRequestHeader(key, headers[key]);
        }

        http.onreadystatechange = function() {
            if(http.readyState === 4) {
                if(http.status == 200) {
                    const response_data = JSON.parse(http.responseText);

                    resolve(response_data);
                }else {
                    try {
                        reject({
                            status: http.status,
                            response: JSON.parse(http.responseText)
                        });
                    }catch(e) {
                        reject({
                            status: http.status,
                            response: http.responseText
                        });
                    }
                }
            }
        }

        http.send(input_data);
    });
}

module.exports = {
    tokenVerify: tokenVerify,
    signout: signout,
    httpRequest
};